import { render, staticRenderFns } from "./Twofactor.vue?vue&type=template&id=3c1b1518&scoped=true&"
import script from "./Twofactor.vue?vue&type=script&lang=js&"
export * from "./Twofactor.vue?vue&type=script&lang=js&"
import style0 from "./Twofactor.vue?vue&type=style&index=0&id=3c1b1518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b1518",
  null
  
)

export default component.exports